<template>
  <transition name="slide-fade">
    <p v-if="show" v-html="notEmptyErrorMessage" />
  </transition>
</template>
<script>
  import {landingPageLogUsingPortal} from "../../utils/logging";
  export default {
    name: 'AlertMsg',
    props: {
      errorMsg: String,
      critical: {
        type: Boolean,
        default: true
      },
      component: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        show: true,
      }
    },
    computed: {
      notEmptyErrorMessage() {
        return this.errorMsg && this.errorMsg.length > 0
          ? this.$t(this.errorMsg) || this.errorMsg
          : this.$t('something_went_wrong')
      },
    },
    mounted() {
      if (this.critical) {
        try {
          (async () => {
            await landingPageLogUsingPortal(
              'Showed alert on the landings page',
              {
                message: "Something went wrong",
                details: this.$t(this.errorMsg, 'en') || this.errorMsg ,
                component: this.component,
                location: window.location.href,
              }
            )
          })()
        } catch (err) {
          // Do nothing
        }
      }
      setTimeout(() => {
        this.show = false
      }, 5000)
    },
  }
</script>
